import React from "react";
import { useParams } from "react-router-dom";
import CustomTemplates from "../WebPages/Deals/CustomTemplate";
import { vlogDetails } from "../../components/template/CustomTemplate/Pages/vlogDetails";

const AddVlog = () => {
  const params = useParams();
  return (
    <CustomTemplates page_type={"vlog_item"} slug={params.id} attributes={vlogDetails} pageComponentEndpoint="vlog-page-components" backRoute="/website/webpages/vlog" backTitle="Vlog List" />
  );
};

export default AddVlog;
